import React, { useCallback, useMemo } from 'react';

import { AdvisorOption } from '../AdvisorOption';

export const EmptyListLoading: React.FC = () => {
  const noop = useCallback(() => {}, []);

  const options = useMemo(
    () =>
      Array.from({ length: 10 }).map((_, index) => (
        <AdvisorOption label="" onSelect={noop} value={0} key={index.toString()} loading />
      )),
    [noop]
  );

  return <>{options}</>;
};
